const OUI = 'OUI';
const NON = 'NON';
const NE_SAIT_PAS = 'NE_SAIT_PAS';
const INDIVIDUEL = 'INDIVIDUEL';
const COLLECTIF = 'COLLECTIF';
const NSP = 'NSP';
const IMMEUBLE = 'IMMEUBLE';
const MAISON = 'MAISON';
const PERMANENT = 'PERMANENT';
const TEMPORAIRE = 'TEMPORAIRE';
const MAUVAISE = 'MAUVAISE';
const INSTABLE = 'INSTABLE';
const BONNE = 'BONNE';
const EXCELLENTE = 'EXCELLENTE';
const PERMANENTES = 'PERMANENTES';
const ALEATOIRES = 'ALEATOIRES';
const ALEATOIRE = 'ALEATOIRE';
const EOLIENNE = 'EOLIENNE';
const ANTENNE_EN_PANNE = 'ANTENNE_EN_PANNE';
const PROBLEME_PREAMPLI = 'PROBLEME_PREAMPLI';
const SIGNAL_ABSENT_OU_FAIBLE = 'SIGNAL_ABSENT_OU_FAIBLE';
const PROBLEME_DIFFUSION = 'PROBLEME_DIFFUSION';
const BROUILLAGE_4G_5G = 'BROUILLAGE_4G_5G';
const AUTRE = 'AUTRE';

const OUI_NON = {
  OUI: OUI,
  NON: NON,

  VALUES: [
    OUI,
    NON
  ]
};

const OUI_NON_NSP = {
  OUI: OUI,
  NON: NON,
  NE_SAIT_PAS: NE_SAIT_PAS,

  VALUES: [
    OUI,
    NON,
    NE_SAIT_PAS
  ],
  DEFAULT_VALUE: OUI
};

const MODE_RACCORDEMENT = {
  INDIVIDUEL: INDIVIDUEL,
  COLLECTIF: COLLECTIF,
  NSP: NSP,

  VALUES: [
    INDIVIDUEL,
    COLLECTIF,
    NSP
  ],
  DEFAULT_VALUE: INDIVIDUEL
};

const TYPE_PROBLEME = {
  TEMPORAIRE: TEMPORAIRE,
  PERMANENT: PERMANENT,

  VALUES: [
    TEMPORAIRE,
    PERMANENT

  ],

  DEFAULT_VALUE: TEMPORAIRE
};

const TYPE_LOGEMENT = {
  IMMEUBLE: IMMEUBLE,
  MAISON: MAISON,

  VALUES: [
    IMMEUBLE,
    MAISON
  ],

  DEFAULT_VALUE: IMMEUBLE
};

const MAUVAISE_INSTABLE_BONNE_EXCELLENTE = {
  MAUVAISE: MAUVAISE,
  INSTABLE: INSTABLE,
  BONNE: BONNE,
  EXCELLENTE: EXCELLENTE,

  VALUES: [
    MAUVAISE,
    INSTABLE,
    BONNE,
    EXCELLENTE
  ],
};

const PERTURBATIONS = {
  PERMANENTES: PERMANENTES,
  ALEATOIRES: ALEATOIRES,

  VALUES: [
    PERMANENTES,
    ALEATOIRES,
  ],
};

const TYPE_CONSTRUCTION = {
  EOLIENNE: EOLIENNE,
  IMMEUBLE: IMMEUBLE,

  VALUES: [
    EOLIENNE,
    IMMEUBLE,
  ],
};

const NATURE_PERTURBATION = {
  ANTENNE_EN_PANNE: ANTENNE_EN_PANNE,
  PROBLEME_PREAMPLI: PROBLEME_PREAMPLI,
  SIGNAL_ABSENT_OU_FAIBLE: SIGNAL_ABSENT_OU_FAIBLE,
  PROBLEME_DIFFUSION: PROBLEME_DIFFUSION,
  BROUILLAGE_4G_5G: BROUILLAGE_4G_5G,
  AUTRE: AUTRE,

  VALUES: [
    ANTENNE_EN_PANNE,
    PROBLEME_PREAMPLI,
    SIGNAL_ABSENT_OU_FAIBLE,
    PROBLEME_DIFFUSION,
    BROUILLAGE_4G_5G,
    AUTRE,
  ],
};

const PERMANENT_ALEATOIRE = {
  PERMANENT: PERMANENT,
  ALEATOIRE: ALEATOIRE,

  VALUES: [
    PERMANENT,
    ALEATOIRE
  ]
};

export { MODE_RACCORDEMENT, TYPE_PROBLEME, TYPE_LOGEMENT, OUI_NON, OUI_NON_NSP,MAUVAISE_INSTABLE_BONNE_EXCELLENTE,
   PERTURBATIONS, TYPE_CONSTRUCTION, NATURE_PERTURBATION, PERMANENT_ALEATOIRE };



// WEBPACK FOOTER //
// ./src/modules/common/model.js